
/*
 * Type Scripts Methods And Events
 */
import Vue from "vue";
import * as _ from "lodash";
import VueRouter from "vue-router";
import About from "./../components/App/Assets/About/About.vue";
import { Component } from "vue-property-decorator";
import { App } from "./../store/modules/App/types";
import EditProfile from "./../components/App/Assets/EditProfile/EditProfile.vue";
import Announcement from "./../components/App/Assets/Announcement/Announcement.vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Utilities } from "./../shared/utilities";
import { State, Action, Getter } from "vuex-class";
import { http } from "@/shared/https";
import { Workspace } from "@/entities";
import AuthService from "./../services/auth.service";
import { User } from "oidc-client";
import { AppConstants as _app } from '@/shared/app.constants';
import SwitchLanguage from '@/components/App/Assets/Language/SwitchLanguage.vue';

const auth = new AuthService();
const namespace: string = "RootApp";
const admin_layout: string = "admin";
const roles = _app.roles;

/*
 * Component's properties and events
 */
@Component({
  components: {
    About,
    EditProfile,
    Announcement,
    Dashboard,
    DashLayout,
    DashItem,
    SwitchLanguage
  }
})
export default class AppsComponent extends Vue {
  @Action("updateLanguage", { namespace:"application" }) updateLanguage: any;
  @Action("updateLanguage", { namespace:"conceptNote" }) conceptUpdateLanguage: any;

  @State("RootApp") app!: App;
  @State("application") application!: Workspace;
  @Action("_appBtnClick", { namespace }) _appBtnClick: any;
  @Action("_appTabClick", { namespace }) _appTabClick: any;
  @Action("_appTileClick", { namespace }) _appTileClick: any;
  @Action("_appAbout", { namespace }) _appAbout: any;
  @Action("_appErrorLog", { namespace }) _appErrorLog: any;
  @Action("_getModuleGroup", { namespace }) _getModuleGroup: any;
  @Getter("renderComponent", { namespace: "dashboard" })
  renderComponents: any;
  @Getter("removeComponent", { namespace: "dashboard" })
  removeComponent: any;
  homePage:string = "/";
  show=false;
  adminModuleAllowedRoles=[_app.appRoles.SuperAdmin,_app.appRoles.SystemAdmin,_app.appRoles.ProgramAdmin,_app.appRoles.InitiativeAdmin,_app.appRoles.MEAdmin,_app.appRoles.CommunicationOfficer]

  get layout() {
    return (this.$route.meta.layout || "defaut_layout") + "-layout";
  }

  get settings() {
    let userMenu: any = [];
    // @ts-ignore
    this.$router.options.routes.forEach(route => {
      auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          auth.getUser().then((user: User) => {
            let menu: any = {}, userRoles = [];
            // handling multiple roles
            if (Array.isArray(user.profile.role_id)) {
              userRoles = userRoles.concat(user.profile.role_id);
            } else {
              userRoles.push(user.profile.role_id);
            }
            if (
              user.profile &&
              user.profile.role_id &&
              route.meta &&
              route.meta.menuName &&
              route.meta.allowedRoles &&
              route.meta.allowedRoles.filter(i => userRoles.indexOf(i) >= 0).length > 0
            ) {
              menu.name = route.meta.menuName;
              menu.Order = route.meta.sortOrder;
              menu.path = route.path;
              userMenu.push(menu);
              userMenu.sort(function(a, b){return a.Order - b.Order});
            }
          });
        }
      });
    });

    this.$store.state.dashboard.tabs = userMenu;
    // @ts-ignore
    this.$store.state.dashboard.openNodes = this.$store.state.RootApp.menu.openNodes;
    // @ts-ignore
    this.$store.state.dashboard.tree = this.$store.state.RootApp.menu.tree;
    // @ts-ignore
    this.$store.state.dashboard.profileClose = this.$store.state.RootApp.profileClose;
    // @ts-ignore
    this.$store.state.dashboard.profileClosePath = this.$store.state.RootApp.profileClosePath;
    return this.$store.state.dashboard;
  }

  /*
   * The mounted() method gives you access to templates and enables interaction with the DOM.
   */
  mounted() {
     auth.isLoggedIn().then((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          auth.getUser().then((user: User) => {
            let userRoles=[]
             if (Array.isArray(user.profile.role_id)) {
              userRoles = userRoles.concat(user.profile.role_id);
            } 
            else {
              userRoles.push(user.profile.role_id);
            }
            userRoles.forEach(id=>
            {
                if(this.adminModuleAllowedRoles.includes(String(id)))
                {
                  this.show=true
                }
                else
                {
                }
            })
          })
        }
      })
      //To Do: add common functionality for updateLanguage.
    this.updateLanguage(this.$root.$i18n.locale);
    this.conceptUpdateLanguage(this.$root.$i18n.locale);

    //#.Current Context
    let context = this.$store.state.RootApp,
      crumbs,
      self = this,
      lang = localStorage.getItem("locale");

    //#.Button tooltip translator
    if (context.buttons) {
      _.forOwn(context.buttons.btn, function(key, val) {
        if (key.tooltip) {
          key.tooltip =
            self.$t(key.tooltip) || key.tooltip;
        }
      });

      context.about.copyRight =
        self.$t(context.about.copyRight) || context.about.copyRight;
      context.about.title =
        self.$t(context.about.title) || context.about.title;
    }

    if (lang != null && lang != "" && lang != undefined)
      self.$vuetify.lang.current = lang;

    //#.Get location storage information
    context.menu.cacheMenus.tabs = localStorage.getItem("vueAppMenuTab");
    context.menu.cacheMenus.module = localStorage.getItem("vueAppModule");
    crumbs = localStorage.getItem("breadcrumbs");

    if (crumbs != null && crumbs != "")
      context.breadcrumbs.list = JSON.parse(crumbs);

    //#.Set location storage information in app state
    if (
      context.menu.cacheMenus.tabs != "" &&
      context.menu.cacheMenus.tabs != null
    ) {
      context.height = "38px !important";
      context.menu.tabs = JSON.parse(context.menu.cacheMenus.tabs);
      context.moduleGroup.name = JSON.parse(
        context.menu.cacheMenus.module
      ).name;
      context.moduleGroup.icon = JSON.parse(
        context.menu.cacheMenus.module
      ).icon;
      context.moduleGroup.color = JSON.parse(
        context.menu.cacheMenus.module
      ).color;
      context.moduleGroup.container = false;
      context.breadcrumbs.enabled = true;
    }

    //#.Checking home page or screen
    if (window.controller && window.area) {
      context.moduleGroup.container = false;
    }

    auth.isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) {
        auth.getUser().then((user: User) => {
            if (user.profile.user_type_id == _app.UserType.Auditor) {
                this.homePage = "/gmsdashboard";
            } else {
                this.homePage = "/dashboard";
            }
        });

        return http
          .get(context.actions.list)
          .then(record => {
            try {
              this._getModuleGroup({
                moduleGroups: record.data.modulGrp,
                menuList: record.data.menu,
                location: record.data.accountingLocation,
                modules: record.data.modules,
                avatar: record.data.Avatar
              });
              if (record.data.announcementCount > 0) {
                let count = record.data.announcementCount;

                _.forOwn(context.buttons.btn, function(key, val) {
                  if (key.name == "announce") {
                    key.count = count;
                  }
                });
              }
            } catch (error) {
              this._appErrorLog({
                error: "app > _getModuleGroup > " + error.message
              });
            }
          })
          .catch(error => {
            this._appErrorLog({
              error: context.actions.list + " > " + error.message
            });
          });
      }
    });
  }

  /** back to home page on logo click */
  backToHome() {
    this.$router.push({
      name: "dashboard",
      query: {}
    });
  }

  /*
   * Translate menu type
   */
  translate(menuType) {
    let self = this;

    _.forOwn(menuType, function(key, val) {
      if (key) {
        key =
          self.$t(key) || key;
      }
    });
  }
}
